import { motion } from "framer-motion";

const chapters = [
    {
        number: "01",
        title: "Responsif Setiap Saat",
        text: "Pesan Anda tidak pernah menunggu. Tim bantuan PUSATCUAN membalas dalam hitungan menit — siang, malam, bahkan dini hari.",
    },
    {
        number: "02",
        title: "Aman & Resmi",
        text: "Hanya dua jalur resmi: WhatsApp +855 96 4453 740 dan Telegram @tpusatcuan. Percakapan terenkripsi, identitas admin terverifikasi.",
    },
    {
        number: "03",
        title: "24 Jam Nonstop",
        text: "Tidak ada kata tutup. Layanan pusatcuan chat beroperasi penuh 7 hari seminggu, 365 hari setahun, termasuk hari libur nasional.",
    },
];

export const Manifesto = () => (
    <section
        id="keunggulan"
        data-testid="manifesto-section"
        className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32"
    >
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-2">
            <div>
                <motion.p
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="mb-4 text-xs font-medium tracking-[0.3em] uppercase text-[#D4AF37]"
                >
                    Mengapa PUSATCUAN
                </motion.p>
                <motion.h2
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.1 }}
                    className="font-serif-display text-3xl font-medium tracking-tight text-white sm:text-5xl"
                >
                    Standar layanan yang tidak pernah tidur.
                </motion.h2>
            </div>

            <div className="flex flex-col justify-center">
                {chapters.map((ch, i) => (
                    <motion.article
                        key={ch.number}
                        data-testid={`manifesto-chapter-${ch.number}`}
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.9, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
                        className="border-b border-[#D4AF37]/15 py-10 first:pt-0 last:border-b-0"
                    >
                        <span className="font-serif-display text-5xl font-light gold-text sm:text-6xl">
                            {ch.number}
                        </span>
                        <h3 className="font-serif-display mt-4 text-2xl font-medium text-white sm:text-3xl">
                            {ch.title}
                        </h3>
                        <p className="mt-3 max-w-md text-sm leading-relaxed text-[#A1A1AA] md:text-base">
                            {ch.text}
                        </p>
                    </motion.article>
                ))}
            </div>
        </div>
    </section>
);
